import React from 'react';
import { useMeasurement } from '~/utility/BinSentry-ui-utility';
import { makeStyles, Table, TableBody, TableHead, TableCell, TableRow, useMediaQuery, useTheme } from '~/lib/bn-material-ui';
import { useOrdersDialogStateSelector } from '../context/orders-dialog-context';
import { SiteFeedOrderRow, firstLastTableElementPadding } from './site-feed-order-row';
import useOptionalColumns from '~/orders/components/use-optional-columns';

const useFeedOrderStyles = makeStyles(({ palette }) => ({
  feedOrderTable: {
    '& thead': {
      backgroundColor: palette.gray[30],
      '& th': {
        padding: '0',
        fontWeight: '700',
        lineHeight: '2rem',
        paddingLeft: '0.5rem',
        ...firstLastTableElementPadding,
      },
    },
  },
}));

export function SiteFeedOrderTable() {
  const styles = useFeedOrderStyles();
  const [daysOrders] = useOrdersDialogStateSelector('daysOrders');
  const orderMeasurement = useMeasurement({ name: 'orderAmount' });

  const theme = useTheme();
  const isMobileView = useMediaQuery(theme.breakpoints.down('md'));
  const optionalColumns = useOptionalColumns();

  return (
    <Table className={styles.feedOrderTable}>
      {!isMobileView && <TableHead>
        <TableRow>
          {optionalColumns.showOrderNumberColumn && <TableCell>Order Number</TableCell>}
          <TableCell>Feed Name</TableCell>
          <TableCell>Formula ID</TableCell>
          <TableCell>Barn Name</TableCell>
          <TableCell>Bin Name</TableCell>
          <TableCell>Order Status</TableCell>
          <TableCell className={styles.quantityCell}>Quantity ({orderMeasurement.unit})</TableCell>
        </TableRow>
      </TableHead>
      }
      <TableBody>
        {daysOrders?.map(order => <SiteFeedOrderRow key={order.getLinkByRel('self').href} order={order} columnConfig={optionalColumns} />)}
      </TableBody>
    </Table>
  );
}
